export default __webpack_public_path__ + "static/media/ill-information.9d2e2fd2.svg";